/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import * as CustomRenderer from 'UIComponents/utils/propTypes/customRenderer';
import { DISTANCE_MEASUREMENT_EXTRA_SMALL } from 'HubStyleTokens/sizes';
import { remCalc } from 'UIComponents/core/Style';
import NameTypes from '../constants/NameTypes';
import SingleNameInput from '../internal/components/SingleNameInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FORMATS = {
  default: [NameTypes.GIVEN_NAME, NameTypes.FAMILY_NAME],
  ja: [NameTypes.FAMILY_NAME, NameTypes.GIVEN_NAME]
};
const NAME_LABELS = {
  [NameTypes.GIVEN_NAME]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "i18nAddon.fullNameInput.givenName"
  }),
  [NameTypes.FAMILY_NAME]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "i18nAddon.fullNameInput.familyName"
  })
};
const nameMargin = parseInt(DISTANCE_MEASUREMENT_EXTRA_SMALL, 10) / 2;
export default class FullNameInput extends Component {
  render() {
    const {
      direction,
      familyNameInput,
      firstInputProps,
      givenNameInput,
      secondInputProps,
      wrap
    } = this.props;
    const lang = getLang();
    const format = FORMATS[lang] ? FORMATS[lang] : FORMATS.default;
    const firstInputType = format[0];
    const secondInputType = format[1];
    const firstLabel = NAME_LABELS[firstInputType];
    const secondLabel = NAME_LABELS[secondInputType];
    const isRow = direction === 'row';
    const wrapBoxStyle = isRow ? {
      margin: remCalc(nameMargin)
    } : null;
    const flexBoxStyle = isRow ? {
      margin: remCalc(nameMargin * -1)
    } : null;
    const containerStyle = isRow ? {
      marginRight: remCalc(nameMargin * -2)
    } : null;
    let firstInput = givenNameInput;
    let secondInput = familyNameInput;
    if (firstInputType === NameTypes.FAMILY_NAME) {
      firstInput = familyNameInput;
      secondInput = givenNameInput;
    }
    return /*#__PURE__*/_jsx("div", {
      style: containerStyle,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: direction,
        wrap: wrap,
        align: "stretch",
        style: flexBoxStyle,
        children: [/*#__PURE__*/_jsx(UIBox, {
          grow: 1,
          style: wrapBoxStyle,
          children: /*#__PURE__*/_jsx(SingleNameInput, Object.assign({}, firstInputProps, {
            input: firstInput,
            label: firstLabel
          }))
        }), /*#__PURE__*/_jsx(UIBox, {
          grow: 1,
          style: wrapBoxStyle,
          children: /*#__PURE__*/_jsx(SingleNameInput, Object.assign({}, secondInputProps, {
            input: secondInput,
            label: secondLabel
          }))
        })]
      })
    });
  }
}
FullNameInput.propTypes = {
  direction: PropTypes.oneOf(['row', 'column']),
  familyNameInput: CustomRenderer.propType.isRequired,
  givenNameInput: CustomRenderer.propType.isRequired,
  wrap: PropTypes.string
};
FullNameInput.defaultProps = {
  direction: 'column',
  wrap: 'nowrap'
};